var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1964 3.28202V11.1958C11.1964 14.6924 8.3619 17.5268 4.86537 17.5268H2.22744M12.7783 30.7164C12.7783 30.7164 14.361 27.5509 14.361 23.3302C14.361 18.7931 19.4332 21.2791 20.8539 14.3471C21.3218 12.0635 23.1093 10.1405 25.4403 10.1405H29.661M32.2992 16.9992C32.2992 25.4492 25.4492 32.2992 16.9992 32.2992C8.54927 32.2992 1.69922 25.4492 1.69922 16.9992C1.69922 8.54927 8.54927 1.69922 16.9992 1.69922C25.4492 1.69922 32.2992 8.54927 32.2992 16.9992Z",
    stroke: "#353A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/Media.6a5e58643b8591ce577fb4d57e271b44.svg";
export { ForwardRef as ReactComponent };